(function () {
  if (window.ElvtdYotpoBadges) return;

  
  var cache = {};
  var STORAGE_PREFIX = 'elvtd-yotpo:';
  var STORAGE_TTL = 24 * 60 * 60 * 1000;
  var COUNT_DURATION = 1200;

  function formatReviewCount(n) {
    return Number(n || 0).toLocaleString('en-US');
  }

  
  function fetchYotpoBottomline(appKey, productId) {
    var scope = productId === 'store' ? '' : '/product/' + encodeURIComponent(productId);
    var url = 'https://api-cdn.yotpo.com/v3/storefront/store/' + encodeURIComponent(appKey) +
      scope + '/reviews?page=1&perPage=1';
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 8000) : null;

    return fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (res) {
        if (!res.ok) throw new Error('Yotpo ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var bottomline = data && data.bottomline;
        if (!bottomline) throw new Error('Yotpo: no bottomline');
        return {
          total: Number(bottomline.totalReview) || 0,
          average: Number(bottomline.averageScore) || 0
        };
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
      });
  }

  function readStored(key) {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_PREFIX + key));
      if (stored && stored.total && Date.now() - stored.t < STORAGE_TTL) {
        return { total: stored.total, average: stored.average };
      }
    } catch (e) {}
    return null;
  }

  function writeStored(key, bottomline) {
    try {
      localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify({
        t: Date.now(),
        total: bottomline.total,
        average: bottomline.average
      }));
    } catch (e) {}
  }

  function getBottomline(appKey, productId) {
    var key = appKey + '|' + productId;
    if (!cache[key]) {
      cache[key] = fetchYotpoBottomline(appKey, productId)
        .then(function (bottomline) {
          if (bottomline.total) writeStored(key, bottomline);
          return bottomline;
        })
        .catch(function () { return null; });
    }
    return cache[key];
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateCount(el, target, label) {
    var suffix = label ? ' ' + label : '';
    if (prefersReducedMotion() || !window.requestAnimationFrame) {
      el.textContent = formatReviewCount(target) + suffix;
      return;
    }
    var start = null;
    function step(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / COUNT_DURATION, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatReviewCount(Math.round(target * eased)) + suffix;
      if (progress < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  
  function replaceNumbers(badge, rating, count) {
    var walker = document.createTreeWalker(badge, NodeFilter.SHOW_TEXT, null);
    var ratingDone = false;
    var countDone = false;
    var node;
    while ((node = walker.nextNode()) && !countDone) {
      var text = node.nodeValue;
      if (!ratingDone) {
        text = text.replace(/\d+\.\d+/, function (m) { ratingDone = true; return rating; });
        if (ratingDone) {
          var idx = text.indexOf(rating) + rating.length;
          var rest = text.slice(idx).replace(/\d{1,3}(,\d{3})+|\d+/, function (m) { countDone = true; return count; });
          text = text.slice(0, idx) + rest;
        }
      } else {
        text = text.replace(/\d{1,3}(,\d{3})+|\d+/, function (m) { countDone = true; return count; });
      }
      node.nodeValue = text;
    }
  }

  function applyYotpoBottomline(badge, bottomline, animate) {
    var ratingEl = badge.querySelector('[data-yotpo-rating]');
    var countEl = badge.querySelector('[data-yotpo-count]');
    var textEl = badge.querySelector('[data-yotpo-text]');

    if (!bottomline || !bottomline.total) {
      applyYotpoFallback(badge);
      return;
    }

    if (textEl) {
      textEl.textContent = bottomline.average.toFixed(1) + ' (' + formatReviewCount(bottomline.total) + ')';
    }
    if (badge.hasAttribute('data-yotpo-replace-numbers')) {
      replaceNumbers(badge, bottomline.average.toFixed(2), formatReviewCount(bottomline.total));
    }
    if (ratingEl) ratingEl.textContent = bottomline.average.toFixed(2);
    if (countEl) {
      var label = countEl.getAttribute('data-yotpo-count-label');
      if (animate && badge.hasAttribute('data-yotpo-animate')) {
        animateCount(countEl, bottomline.total, label);
      } else {
        countEl.textContent = formatReviewCount(bottomline.total) + (label ? ' ' + label : '');
      }
    }
    badge.setAttribute('data-yotpo-source', 'yotpo');
    badge.classList.remove('is-yotpo-loading');
    badge.removeAttribute('hidden');
  }

  function applyYotpoFallback(badge) {
    var textEl = badge.querySelector('[data-yotpo-text]');
    badge.setAttribute('data-yotpo-source', 'fallback');
    badge.classList.remove('is-yotpo-loading');
    if (!textEl) return;
    var fallback = badge.getAttribute('data-yotpo-fallback') || '';
    textEl.textContent = fallback;
    if (fallback) badge.removeAttribute('hidden');
    else badge.setAttribute('hidden', '');
  }

  function applyToMatches(appKey, productId, bottomline, animate) {
    var matches = document.querySelectorAll('[data-yotpo-badge]');
    Array.prototype.forEach.call(matches, function (badge) {
      if (badge.getAttribute('data-yotpo-app-key') !== appKey) return;
      if (badge.getAttribute('data-yotpo-product-id') !== productId) return;
      if (bottomline) applyYotpoBottomline(badge, bottomline, animate);
      else if (badge.getAttribute('data-yotpo-source') !== 'yotpo') applyYotpoFallback(badge);
    });
  }

  function init(root) {
    var badges = (root || document).querySelectorAll('[data-yotpo-badge]:not([data-yotpo-bound])');
    var requests = {};

    Array.prototype.forEach.call(badges, function (badge) {
      badge.setAttribute('data-yotpo-bound', 'true');
      var appKey = badge.getAttribute('data-yotpo-app-key');
      var productId = badge.getAttribute('data-yotpo-product-id');
      if (appKey && productId) requests[appKey + '|' + productId] = [appKey, productId];
      else applyYotpoFallback(badge);
    });

    Object.keys(requests).forEach(function (key) {
      var appKey = requests[key][0];
      var productId = requests[key][1];
      var stored = readStored(key);
      if (stored) applyToMatches(appKey, productId, stored, false);
      getBottomline(appKey, productId).then(function (bottomline) {
        if (stored && bottomline && bottomline.total === stored.total && bottomline.average === stored.average) return;
        applyToMatches(appKey, productId, bottomline, !stored);
      });
    });
  }

  window.ElvtdYotpoBadges = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target ? event.target : document);
  });
})();
